import { type LinkSection } from "@/data/site";
import { useSiteContent } from "@/data/SiteContentContext";
import { ExternalLinkCard } from "@/components/LinkCards";

const copy = {
  gear: {
    eyebrow: "// gear",
    title: "Gear I Reach For",
    intro: "Hardware and accessories that earn a permanent spot in the bag or on the desk.",
  },
  apps: {
    eyebrow: "// apps",
    title: "Favorite Apps",
    intro: "Mac and cross-platform tools I install on day one.",
  },
  services: {
    eyebrow: "// services",
    title: "Favorite Services",
    intro: "Subscriptions, platforms, and vendors I trust with my time, money, or stack.",
  },
} as const;

export function LinksPage({ variant }: { variant: keyof typeof copy }) {
  const { gearSections, appSections, serviceSections } = useSiteContent();
  const sections = { gear: gearSections, apps: appSections, services: serviceSections }[variant];
  const page = { ...copy[variant], sections };

  return (
    <div className="space-y-12">
      <header className="max-w-2xl space-y-3">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-[var(--color-primary)]">{page.eyebrow}</p>
        <h1 className="text-4xl font-semibold tracking-tight">{page.title}</h1>
        <p className="text-lg text-[var(--color-muted)]">{page.intro}</p>
      </header>

      {page.sections.map((section: LinkSection) => (
        <section key={section.title}>
          <h2 className="mb-4 text-xl font-semibold tracking-tight">{section.title}</h2>
          <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
            {section.items.map((item) => (
              <ExternalLinkCard key={item.url} item={item} />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
